'use strict';


module.exports = require('./lib/');



//////////////////
// WEBPACK FOOTER
// ./node_modules/markdown-it/index.js
// module id = 560
// module chunks = 0